"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
export default function TenantFaq() {
  const faqs = [{
    question: "How do I arrange a viewing?",
    answer: <>
          Booking a viewing is simple. You can request a viewing directly through
          any property listing on our website, or you can{" "}
          <Link to="/ContactPage" className="text-white underline underline-offset-4 hover:text-primary">
            contact our team
          </Link>{" "}
          to schedule an appointment that suits your schedule.
        </>
  }, {
    question: "What references will I need to provide?",
    answer: "To ensure a smooth application process, we typically require proof of identity (passport or driving licence), proof of address, three months of bank statements, and an employment reference. In some cases, a previous landlord reference may also be requested."
  }, {
    question: "How much is the holding deposit?",
    answer: "A holding deposit equivalent to one week's rent is usually required to reserve a property while we complete your reference checks. This amount is later deducted from your first month's rent upon successful completion of the tenancy agreement."
  }, {
    question: "Are bills included in the rent?",
    answer: "Unless explicitly stated in the property description, bills such as council tax, water, gas, electricity, and broadband are not included in the rent. We recommend checking the specific details of each property listing."
  }, {
    question: "What should I do in an emergency?",
    answer: <>
          For urgent maintenance issues that pose a risk to safety or the
          property, please contact our 24/7 emergency line immediately at{" "}
          <span className="text-white font-medium">+44 20 7946 0123</span>. For
          non-urgent matters, please submit a maintenance request through our
          tenant portal.
        </>
  }];
  return <section id="tenant-faq" className="dark bg-background py-24 sm:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 max-w-2xl relative z-10">
        <div className="text-center mb-16 space-y-4">
          <h2 className="font-serif text-4xl md:text-5xl text-foreground tracking-tight">
            Your Questions, Answered.
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-lg mx-auto font-light">
            Everything you need to know about renting your next home with
            LiveAmazing.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-white/20 last:border-b-0" data-index={i}>
              <AccordionTrigger className="text-lg md:text-xl font-medium text-foreground hover:text-primary transition-colors py-6 text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base md:text-lg leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}